import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: number;
  title: string;
  category: string;
  year: number;
  rating: number;
  posterUrl: string;
  status: string;
  categoryName: string;
}

export default function VideoCard({ id, title, year, rating, posterUrl, status, categoryName }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200 mb-3">
        <img
          src={posterUrl}
          alt={title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 rounded text-xs font-medium bg-primary-500 text-white">
            {rating}
          </span>
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 rounded text-xs font-medium bg-background-900/70 text-foreground-100">
            {status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <span className="text-xs text-foreground-100/70">{categoryName} · {year}</span>
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
            <i className="ri-play-fill text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-950 leading-tight line-clamp-1 group-hover:text-primary-500 transition-colors">
        {title}
      </h3>
    </Link>
  );
}